import { Box } from '@mui/material'
import React from 'react'
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import CottageIcon from '@mui/icons-material/Cottage';
import PropaneTankIcon from '@mui/icons-material/PropaneTank';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import { customStyles, justifyCenter } from '../../styles';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import ApartmentIcon from '@mui/icons-material/Apartment';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import ForestIcon from '@mui/icons-material/Forest';
import ParkIcon from '@mui/icons-material/Park';
import LandscapeIcon from '@mui/icons-material/Landscape';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import ElderlyWomanIcon from '@mui/icons-material/ElderlyWoman';
import EscalatorWarningIcon from '@mui/icons-material/EscalatorWarning';

const iconStyle = {
  color: customStyles.colors.main,
  fontSize: 50,
}
export const TruckAnimation = () => {
  return (
    <Box mt={2}sx={{ position: 'relative', width: '100%', height: 150, 
    
     ...justifyCenter, overflow: 'hidden' }}>

      <LocalShippingIcon className="truck" sx={{...iconStyle, color: customStyles.colors.main}}/>
      {
      /* <CottageIcon sx={iconStyle}/>
      <PropaneTankIcon sx={iconStyle}/>
      <EmojiEmotionsIcon sx={iconStyle}/> */}
      <CottageIcon className="home" sx={{...iconStyle,  fontSize: 30}}/>
      <HomeWorkIcon className="home" sx={{...iconStyle,  fontSize: 50, animationDelay: '5s', zIndex: 5}}/>
      <ApartmentIcon className="home" sx={{...iconStyle,  fontSize: 20, animationDelay: '1s', zIndex: 5}}/>
      <LocationCityIcon className="home" sx={{...iconStyle,  fontSize: 60, animationDelay: '4s', zIndex: 5}}/>
      <CottageIcon className="home" sx={{...iconStyle,  fontSize: 80}}/>
      <HomeWorkIcon className="home" sx={{...iconStyle,  fontSize: 30, animationDelay: '2s', zIndex: 5}}/>
      <ApartmentIcon className="home" sx={{...iconStyle,  fontSize: 50, zIndex: 5}}/>
      <LocationCityIcon className="home" sx={{...iconStyle,  fontSize: 40, animationDelay: '7s', zIndex: 5}}/>
      <ApartmentIcon className="home" sx={{...iconStyle,  fontSize: 10, animationDelay: '3s', zIndex: 5}}/>
      <LocationCityIcon className="home" sx={{...iconStyle,  fontSize: 30, animationDelay: '6s', zIndex: 5}}/>
      <CottageIcon className="home" sx={{...iconStyle,  fontSize: 50}}/>
      <HomeWorkIcon className="home" sx={{...iconStyle,  fontSize: 40, animationDelay: '8s', zIndex: 5}}/>
      <ApartmentIcon className="home" sx={{...iconStyle,  fontSize: 60, zIndex: 5}}/>
      <LocationCityIcon className="home" sx={{...iconStyle,  fontSize: 40, animationDelay: '10s', zIndex: 5}}/>
      {/* <Box className="street" sx={{border: `1px solid ${customStyles.colors.textColor}`, height: '1px', width: 40, marginTop: 4, opacity: .5}}></Box>
      <Box className="street2" sx={{border: `1px solid ${customStyles.colors.textColor}`, height: '1px', width: 40, marginTop: 4, opacity: .5, }}></Box> */}
    </Box>
  )
}
